"use strict";
/**
 * This file was auto-generated by Fern from our API Definition.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.ReturnChatPagedEventsStatus = void 0;
exports.ReturnChatPagedEventsStatus = {
    Active: "ACTIVE",
    UserEnded: "USER_ENDED",
    UserTimeout: "USER_TIMEOUT",
    MaxDurationTimeout: "MAX_DURATION_TIMEOUT",
    InactivityTimeout: "INACTIVITY_TIMEOUT",
    Error: "ERROR",
};
